import { render, staticRenderFns } from "./EmailEngagement.vue?vue&type=template&id=5e480046&"
import script from "./EmailEngagement.vue?vue&type=script&lang=js&"
export * from "./EmailEngagement.vue?vue&type=script&lang=js&"
import style0 from "./EmailEngagement.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports